import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-image-carousel',
  imports: [CommonModule],
  templateUrl: './image-carousel.component.html',
  styleUrl: './image-carousel.component.scss'
})
export class ImageCarouselComponent implements AfterViewInit {
  @Input() carouselItems: any;
  isAtStart = true;
  isAtEnd = false;
  @ViewChild('carouselWrapper', { static: true }) carouselWrapper!: ElementRef;
  @Output() selectProject = new EventEmitter<string>();

  constructor(private router: Router,) {}

  ngAfterViewInit(): void {
    this.checkScrollPosition();
    this.carouselWrapper.nativeElement.addEventListener('scroll', () => this.checkScrollPosition());
  }
  
  //Carousel Scrolling
  scrollLeft() {
    this.carouselWrapper.nativeElement.scrollBy({ left: -320, behavior: 'smooth' });
    this.checkScrollPosition();
  }

  scrollRight() {
    this.carouselWrapper.nativeElement.scrollBy({ left: 320, behavior: 'smooth' });
    this.checkScrollPosition();
  }

  checkScrollPosition() {
    const el = this.carouselWrapper.nativeElement;
    const maxScroll = el.scrollWidth - el.clientWidth;

    this.isAtStart = el.scrollLeft <= 0;
    this.isAtEnd = el.scrollLeft >= maxScroll - 1; // -1 for float precision
  }

  /**
   * A project page is only worth opening once it has a problem statement and a
   * solution — without them the detail page is empty, so the card stays inert.
   */
  isOpenable(item: any): boolean {
    return !!item?.problemStatement?.trim() && !!item?.solution?.trim();
  }

  goToProject(item: any) {
    if (!this.isOpenable(item)) {
      return;
    }
    // this.router.navigate(['/projects', projectTitle]);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/projects', item.title]);
    });
    //   this.selectProject.emit(projectTitle);
  }
}
